<template>
  <section>
    <div class="d-flex justify-content-center my-5">
      <h1 class="center title">Demande de devis</h1>      
    </div>
    <div v-if="!showDetailsForm" class=" container d-flex justify-content-between flex-wrap" >
      <DemandeCard :key="index" v-for="(demande, index) in demandes" :demande="demande" @details="showDetails"  @refresh="getData" />
    </div>
  <DemandeDetails v-if="showDetailsForm" :demande="this.demande" @refresh="getData" @cancel="getData" />
  </section>
</template>

<script>
import DemandeCard from './components/demande/DemandeCard.vue';
import DemandeDetails from './components/demande/DemandeDetails.vue'
import axios from 'axios'
import APIs from "@/../config";
export default {
    name: "Recrute",
    data() {
        return {
            addPost : false , 
            demandes : [] , 
            post : {} , 
            showDetailsForm : false
        };
    },
    created() {
        this.getData()
    },
    methods: {
        showDetails(demande){
            this.demande = demande
            this.showDetailsForm = !this.showDetailsForm
        },
        getData(){
            var get_token = localStorage.getItem('token')
            var user_id = localStorage.getItem('user_id')
          axios.get(`${APIs.API_URL}/demande/${user_id}` ,  {
                    headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${get_token}`
                    }
                })
          .then(res => {
            this.demandes = res.data
          
            
          }).catch(error => {
              console.error(error)
          })
          this.showDetailsForm = false
        },
        AddAction(){
            this.addPost = !this.addPost
        },
        updateAction(post){
          this.showUpdateForm = !this.showUpdateForm
          this.toUpdate = post
        },
    },
    components: { DemandeCard , DemandeDetails} 
}

</script>

<style lang="scss" scoped>
  .boxs{
    display: flex;
    justify-content: space-around;
    width: 94%;
    margin-left: 3%;
    .box{
      background-color: rgb(236, 236, 236);
      height: 200px;
      width: 400px;
      border-radius: 10px;
      cursor:pointer;
      .buttons{
        top: 60%;
        position: relative;
        display: flex;
        justify-content: space-around;
        .btn-light{
          background-color:rgb(236, 236, 236) ;
          color: rgb(236, 236, 236);
          box-shadow: none;
          width: 140px;
        }
      }
    }
    :hover{
      background:rgb(236, 236, 236);
      .buttons{
        .delete{
          background-color:red  ;
          color: white;
        }
      }
    }
  }
</style>